/**
 * Swiss VAT rate applied to subscription billing.
 *
 * This rate changed from 7.7 % to 8.1 % on 1 January 2024.
 * It must stay in sync with BILLING_TAX_RATE in digital-billing.
 *
 * Neither the catalog API nor the subscription snapshot currently
 * exposes the tax rate. When billing adds it to a response, this
 * constant should be replaced by the API value.
 */
export const BILLING_VAT_RATE = 8.1;

/**
 * Number of days before subscription start that the invoice is issued.
 * Mirrors digital-billing issue_offset_days per billing cycle.
 */
export const INVOICE_ISSUE_OFFSET_DAYS: Record<string, number> = {
  monthly: 15,
  yearly: 30,
};

/** Terms & conditions URL — opened in a new tab from the confirmation modal. */
export const TERMS_URL = 'https://digitaladmin.ch/conditions-generales-de-vente';
